<template>
  <div>
    <!-- FAST ENTRY -->
    <h-numeric-menu
      v-if="config('fastMenuEntry')"
      v-model="fastMenuQuantity"
      :title="__('fastMenuEntry')"
      display="6"
      light
      color="white"
      :min="minQuantity"
      @input="fastMenuEntry()"
    >
      <template #activator="{ attrs, on }">
        <h-item
          v-bind="attrs"
          v-on="on"
          :item="item"
          :count="count"
          icon="menu"
        />
      </template>
    </h-numeric-menu>
    <!-- REGULAR ENTRY -->
    <h-item
      v-else
      :item="item"
      :count="count"
      icon="menu"
      @click="regularEntry()"
    />
    <!-- MENU -->
    <h-fs-dialog :value="menuDialog">
      <h-menu
        @close="menuDialog = false"
        @complete="addMenu"
      />
    </h-fs-dialog>
  </div>
</template>

<script>
  import ChecksMinQuantity from '@/Mixins/ChecksMinQuantity'
  import Configurable from '@/Mixins/Configurable'
  import I18n from '@/Mixins/I18n'
  import HNumericMenu from '@/Components/NumericMenu'
  import HFsDialog from '@/Components/FullScreenDialog'
  import HMenu from '@/Sections/Order/Menu/Card'
  import HItem from './Item'

  export default {
    mixins: [
      ChecksMinQuantity,
      Configurable,
      I18n,
    ],

    components: {
      HNumericMenu,
      HFsDialog,
      HMenu,
      HItem,
    },

    props: {
      item: {
        required: true,
        type: Object,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      menuDialog: false,
      fastMenuQuantity: 0,
    }),

    computed: {
      count () {
        return this.$store.getters['orders/itemCounter'](this.item.id)
      },
      minQuantity () {
        return this.order.minQuantityToAdd(this.item) || 1
      },
    },

    methods: {
      regularEntry () {
        if (this.disabled) {
          return
        }
        this.checkMinQuantity(this.item)
        this.openMenu(this.minQuantity)
      },
      fastMenuEntry () {
        this.openMenu(this.fastMenuQuantity)
        this.resetFastMenuQuantity()
      },
      resetFastMenuQuantity () {
        setTimeout(() => this.fastMenuQuantity = 0, 50)
      },
      openMenu (quantity) {
        this.$store
          .dispatch('orders/menu/init', { item: this.item, quantity })
          .then(() => this.menuDialog = true)
      },
      addMenu () {
        this.$store.dispatch('orders/addMenu')
      },
    },
  }
</script>
